import {
  primitiveColor
} from "./chunk-TUU3BKKT.mjs";

// src/tokens/component/baseComponent.ts
var baseComponent = (theme) => {
  return {
    button: {
      solidPrimary: {
        background: theme.brand.default,
        backgroundHover: theme.brand.strong,
        text: primitiveColor.neutral[0],
        icon: primitiveColor.neutral[0]
      },
      solidSecondary: {
        background: primitiveColor.neutral[100],
        backgroundHover: primitiveColor.neutral[80],
        text: theme.text.inverse,
        icon: theme.icon.inverse
      },
      solidTertiary: {
        background: primitiveColor.neutral[20],
        backgroundHover: primitiveColor.neutral[30],
        text: theme.text.secondary,
        icon: theme.icon.secondary
      },
      solidError: {
        background: primitiveColor.red[70],
        backgroundHover: primitiveColor.red[80],
        text: primitiveColor.neutral[0],
        icon: primitiveColor.neutral[0]
      },
      outlinePrimary: {
        border: theme.brand.default,
        background: primitiveColor.neutral[0],
        backgroundHover: theme.brand.subtlest,
        text: theme.brand.default,
        icon: theme.brand.default
      },
      outlineSecondary: {
        border: primitiveColor.neutral[30],
        background: primitiveColor.neutral[0],
        backgroundHover: primitiveColor.neutral[10],
        text: theme.text.secondary,
        icon: theme.icon.secondary
      }
    }
  };
};

export {
  baseComponent
};
